(function () {
  const map = {
    "White": "Blanco",
    "Red": "Rojo",
    "Blue": "Azul",
    "Yellow": "Amarillo",
    "Green": "Verde",
    "Pink": "Rosado",
    "Black": "Negro",
    "Beige": "Beige",
    "Navy": "Azul oscuro",
    "Ivory": "Marfil"
  };

  function translateColorText() {
    // Cambia "Color: WHITE" por "Color: Blanco"
    document.querySelectorAll('*').forEach(el => {
      if (el.children.length) return;
      const txt = (el.textContent || '').trim();
      if (/^color:\s*/i.test(txt)) {
        const parts = txt.split(':');
        const value = (parts[1] || '').trim();
        if (map[value]) el.textContent = parts[0] + ': ' + map[value];
      }
    });

    // Tooltips / aria en swatches
    document.querySelectorAll('[data-value]').forEach(sw => {
      const v = sw.getAttribute('data-value');
      if (map[v]) {
        sw.setAttribute('aria-label', map[v]);
        sw.setAttribute('title', map[v]);
      }
    });
  }

  translateColorText();

  document.addEventListener('change', function () {
    setTimeout(translateColorText, 50);
  });

  document.addEventListener('variant:change', function () {
    setTimeout(translateColorText, 50);
  });
})();
